export default {
      retornaAnexo(arquivo,
                   nome_anexo,
                   tipo_de_anexo,
                   extensoesValidas = null,
                   tamanho_maximo_mb = 5){
            const tipo_arquivo = retornaExtensaoDeNomeDoArquivo(arquivo);

            const tamanho_arquivo_mb = this.tamanhoDoArquivoEmMb(arquivo);

            const tamanho_arquivo_kb = this.tamanhoDoArquivoEmKb(arquivo);

            nome_anexo = _.snakeCase(_.replace(nome_anexo, `.${tipo_arquivo}`, '')) + '.' + tipo_arquivo;

            const tipo_arquivo_extenso = retornaTipoDoArquivo(arquivo);

            if(tamanho_arquivo_mb > tamanho_maximo_mb){
                  Swal.fire('Arquivo inválido!', `O tamanho do arquivo não pode ser maior que ${tamanho_maximo_mb} mb (megabytes)`, 'error');
                  return false;
            }

            if(extensoesValidas != null){
                  const encontrou = _.find(extensoesValidas, (extensao_valida) => {
                        return extensao_valida.toLowerCase() === tipo_arquivo.toLowerCase()
                  }) != null

                  if(!encontrou){
                        Swal.fire('Arquivo inválido!', `É permitido somente o upload de arquivo(s) com a(s) seguinte(s) extensões: ${ _.join(extensoesValidas, '|') }`, 'error')
                        return false
                  }
            }

            return {
                  id: null,
                  tipo_de_anexo: tipo_de_anexo,
                  //caminho_completo: null,
                  nome_arquivo: null,
                  nome_anexo: nome_anexo,
                  tamanho_arquivo_kb: tamanho_arquivo_kb,
                  tamanho_arquivo_mb: tamanho_arquivo_mb,
                  tipo_arquivo: tipo_arquivo,
                  tipo_arquivo_extenso: tipo_arquivo_extenso,
                  arquivo: arquivo
            }
      },

      tamanhoDoArquivoEmKb(arquivo) {
            return arquivo.size / 1024;
      },

      tamanhoDoArquivoEmMb(arquivo) {
            return ((arquivo.size / 1024) / 1024);
      },

      linkParaDownloadDeAnexosEmGeral(anexo){
            if(anexo.id != null)
                  return `/anexos/download/${anexo.id}`
            else{
                  return linkParaArquivoTemporario(anexo.arquivo, anexo.tipo_arquivo_extenso)
            }
      },

      linkParaDownloadDeAnexosDeItemDaInscricao(anexoId = null, arquivo = null, tipo_arquivo_extenso = null){
            if(anexoId != null)
                  return `/anexos/download/${anexoId}`
            else{
                  return linkParaArquivoTemporario(arquivo, tipo_arquivo_extenso)
            }
      },
}

function linkParaArquivoTemporario(arquivo, tipo_arquivo_extenso){
      let file = arquivo;
      let fr = new FileReader();
      fr.readAsDataURL(file);

      let blob = new Blob([file], { type: tipo_arquivo_extenso });// change resultByte to bytes

      return window.URL.createObjectURL(blob);
}

function retornaExtensaoDeNomeDoArquivo(arquivo){
	  return arquivo.name.substring(arquivo.name.lastIndexOf('.') + 1);
}

function retornaTipoDoArquivo(arquivo){
      if(arquivo.type === undefined || arquivo.type == null || arquivo.type === '')
            return retornaExtensaoDeNomeDoArquivo(arquivo)
      else
            return arquivo.type
}
